import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: #ffffff;
        overflow-x: hidden;
    }

    a:hover {
        color: #101e9fff;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #02888fff;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 40px;
        }

        @media only screen and (max-width: 768px) {
          font-size: 32px;
        }

        @media only screen and (max-width: 576px) {
          font-size: 28px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 24px;
        }
    }

    p {
        color: #565655;
        font-size: 21px;        
        line-height: 1.41;

        @media only screen and (max-width: 768px) {
          font-size: 18px;
        }

        @media only screen and (max-width: 576px) {
          font-size: 16px;
        }

        @media only screen and (max-width: 414px) {
          font-size: 14px;
        }
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    #intro {
        
        
        h6 {
           
            line-height: 1.3;
            color: #02888f;
            margin-bottom: 3rem;
            
        }
        
        p {
            color: #565655;
            font-weight: bold;
        }
    }

    #servicios {
        p {
            text-align: justify;
        }
    }

    #tecnologias {
        p {
            text-align: justify;
        }
    }

    #clientes {
        /* Logo row: flex gap shrinks on smaller screens */
        .clients-logos {
            gap: 3rem;

            @media only screen and (max-width: 768px) {
                gap: 1rem;
            }

            @media only screen and (max-width: 576px) {
                gap: 0.5rem;
            }

            @media only screen and (max-width: 414px) {
                gap: 0.25rem;
            }
        }

        /* Each logo: preserve aspect ratio, scale down on small screens */
        .client-logo {
            height: auto;
            object-fit: contain;
            max-width: 45%;

            @media only screen and (max-width: 890px) {
                max-width: 42%;
            }

            @media only screen and (max-width: 576px) {
                max-width: 40%;
            }

            @media only screen and (max-width: 414px) {
                max-width: 38%;
            }
        }
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

  .video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}

.video-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}


`;
